import { render, staticRenderFns } from "./MailingProfileInfo.vue?vue&type=template&id=a672253e&"
import script from "./MailingProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./MailingProfileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports